<script>
import { onMount } from "svelte";



export let value = ""
export let values = []
export let labels = []

</script>
<select class="inspector" bind:value={value}>
    {#each values as v, i}
        <option value={v}>{labels[i]}</option>
    {/each}
</select>
<style>

select {
    border:none;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    -ms-appearance: none; /* get rid of default appearance for IE8, 9 and 10*/
    /* margin-left: -10px; */
    /* padding-left: 10px; */
}

</style>